<!-- 申请发票页面 -->
<template>
    <div class="sld_my_balance">
        <InvoiceMemberTitle :memberTitle="'申请发票'"></InvoiceMemberTitle>

        <!-- 内容 -->
        <div class="bill_content">
            <div class="steps">
                <div class="item flex_column_center_center">
                    <div class="circle circle_active">1</div>
                    <div class="tit">选择开票订单</div>
                </div>
                <div class="item flex_column_center_center">
                    <div class="circle" :class="isNext ? 'circle_active' : ''">2</div>
                    <div class="tit">确认开票信息</div>
                </div>
            </div>

            <div v-if="!isNext">
                <div class="tables">
                    <el-table :data="orderList.data" style="width: 100%;" empty-text="暂无内容"
                        :header-cell-style="{ 'text-align': 'center', 'background': '#fafafa' }"
                        :cell-style="{ 'text-align': 'center' }" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="63" />
                        <el-table-column prop="orderSn" label="订单编号" width="339" />
                        <el-table-column prop="orderAmount" label="订单金额" width="220" />
                        <el-table-column prop="payTime" label="付款时间" width="472" />
                    </el-table>
                </div>

                <!-- 分页 -->
                <div class="pageTo">
                    <el-pagination background layout="prev, pager, next" :total="paginationList.total"
                        :page-size="paginationList.pageSize" v-model:currentPage="paginationList.current"
                        @current-change="handleCurrentListChange" class="flex_row_end_center" />
                </div>
                <!-- 下一步 -->
                <div class="next">
                    <el-button class="btn" @click="nextBtn" :disabled="orderList.data.length == 0"
                        :class="orderList.data.length == 0 ? 'activeBtn' : ''">下一步</el-button>
                </div>
            </div>

            <div v-else class="toNext">
                <div class="list">
                    <div class="item">
                        <text>发票抬头：</text>
                        <text>{{ invoiceInfo.data.invoiceTitle }}</text>
                    </div>
                    <div class="item">
                        <text>发票类型：</text>
                        <text>{{ invoiceInfo.data.invoiceTypeValue }}</text>
                    </div>
                    <div class="item">
                        <text>电子邮箱：</text>
                        <text>{{ GetPageEmail ? GetPageEmail : '暂无邮箱' }}</text>
                        <text class="default" v-if="DefaultEmail">默认</text>
                        <text v-if="!GetPageEmail" class="choose" @click="addOrEditEmail(1)">新增</text>
                        <text v-if="GetPageEmail" class="choose" @click="addOrEditEmail(2)">选择</text>
                    </div>
                </div>
                <div class="sumit">
                    <el-button class="btn" @click="applyInvoice">提交申请</el-button>
                </div>
            </div>
        </div>


        <!-- 添加电子邮箱 start -->
        <el-dialog :title="addEmailTitle" v-model="emailFlag" width="510px" lock-scroll="false" top="10%"
            :before-close="closeEmail">
            <div v-if="addEmailTitle != '选择电子邮箱'">
                <div class="Invoice_item flex_row_start_center">
                    <div class="title">电子邮箱：</div>
                    <input type="text" v-model="changeEmailVal" placeholder="请输入电子邮箱" class="Invoice_item_input">
                </div>
                <div class="Invoice_item flex_row_start_center">
                    <div class="title">是否默认：</div>
                    <el-switch size="large" v-model="switchVal" />
                </div>
            </div>

            <!-- 选择电子邮箱 -->
            <div v-else class="chooseEmail">
                <div class="email_item"
                    :class="isCheck && item.emailId == isCheck ? 'active' : item.isDefault == 1 && !isCheck ? 'active' : ''"
                    v-for="(item, index) in emailList.data" :key="index" @click="chooseEmail(item)">

                    <div class="choose_left">
                        <text>{{ item.email }}</text>
                        <text v-if="item.isDefault == 1">默认</text>
                    </div>
                    <div class="choose_right" @click.stop="EditEmail(item)">编辑</div>
                </div>
                <div class="flex_row_center_center">
                    <el-pagination background layout="prev, pager, next" :total="pagination.total"
                        :hide-on-single-page="true" :page-size="pagination.pageSize"
                        v-model:currentPage="pagination.current" @current-change="handleCurrentChange" />
                </div>
                <div class="addEmail inline-item" @click="EditEmail(-1)">添加电子邮箱</div>
            </div>

            <template #footer>
                <span class="dialog-footer">
                    <el-button class="el_btn_close" size="small" @click="closeEmail"
                        v-if="addEmailTitle == '选择电子邮箱'">取消</el-button>
                    <el-button class="el_btn_close" size="small" @click="backEmailList" v-else>取消</el-button>

                    <el-button class="el_btn_sub" size="small" @click="subEmail" v-if="addEmailTitle == '选择电子邮箱'">
                        确定
                    </el-button>
                    <el-button class="el_btn_sub" size="small" @click="submitBtn" v-else>
                        确定
                    </el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 添加电子邮箱 end -->

    </div>
</template>
  
<script>
import { ref, reactive, getCurrentInstance, onMounted } from 'vue'
import InvoiceMemberTitle from '../../../components/InvoiceMemberTitle.vue';
import {
    ElMessage
} from "element-plus";
export default {
    name: "Balance",
    components: {
        InvoiceMemberTitle,
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const isNext = ref(false)
        const GetPageEmail = ref('') //邮箱
        const DefaultEmail = ref(false) //是否是默认邮箱
        const emailFlag = ref(false);//添加电子邮箱
        const addEmailTitle = ref('选择电子邮箱')  //添加电子邮箱
        const changeEmailVal = ref('')
        const switchVal = ref(false) //是否默认
        const checkEmail = ref('') //点击确定之后修改邮箱
        const checkisCheck = ref('')
        const isFirst = ref(true) //第一次 未更改状态
        const isCheck = ref('')
        const itemIsDefalut = ref(false)
        const checkType = ref(1) // 添加或者编辑事件 1 添加 2 编辑
        const invoiceId = ref('') // 选择发票的id
        const invoiveOrderSn = ref('') // 选择发票的订单号
        const invoiceInfo = reactive({
            data: {}
        }) //发票抬头信息
        const pagination = reactive({
            current: 1,
            pageSize: 5,
            total: 0
        })

        const paginationList = reactive({
            current: 1,
            pageSize: 10,
            total: 0
        })
        const emailList = reactive({ data: [] })
        const orderList = reactive({ data: [] })


        // 下一步
        const nextBtn = () => {
            if (invoiveOrderSn.value == '') {
                ElMessage.error('请选择要开票的订单')
                return
            }
            isNext.value = true
        }

        const addEmail = () => {
            emailFlag.value = true
            if (emailList.data.length > 0) {
				checkType.value = 2
				addEmailTitle.value = '选择电子邮箱'
			} else {
				addEmailTitle.value = '添加电子邮箱'
				changeEmailVal.value = ''
				switchVal.value = false
				isCheck.value = ''
				checkType.value = 1
			}
        }
        const GoEditEmail = () => {
            emailFlag.value = true
            addEmailTitle.value = '选择电子邮箱'
            pagination.current = 1
            checkType.value = 2
            getEmail()
        }
        //页数改变
        const handleCurrentChange = current => {
            pagination.current = current;
            getEmail();
        };

        // 选择邮箱
        const chooseEmail = (item) => {
            isCheck.value = item.emailId
            checkEmail.value = item.email
            itemIsDefalut.value = item.isDefault
            // console.log(12121)
        }

        // 编辑邮箱
        const EditEmail = (item) => {
            if (item != -1) {
                addEmailTitle.value = '编辑电子邮箱'
                changeEmailVal.value = item.email
                switchVal.value = item.isDefault == 1 ? true : false
                // isCheck.value = item.emailId
            } else {
                addEmailTitle.value = '添加电子邮箱'
                changeEmailVal.value = ''
                switchVal.value = false
                // isCheck.value = ''
            }
        }


        const closeEmail = () => {
            if (addEmailTitle.value == '选择电子邮箱') {
                emailFlag.value = false
            }
            addEmailTitle.value = '选择电子邮箱'
            pagination.current = 1
            switchVal.value = false
            changeEmailVal.value = ''
            if (checkType.value == 1) {
                emailFlag.value = false
            }
        }

        // 返回电子邮箱列表
        const backEmailList = () => {
            addEmailTitle.value = '选择电子邮箱'
            // pagination.current = 1
            switchVal.value = false
            changeEmailVal.value = ''
            if (checkType.value == 1) {
                emailFlag.value = false
            }
        }


        const subEmail = () => {
            if (checkEmail.value =='') {
				ElMessage.error('请选择邮箱');
				return
			}
            GetPageEmail.value = checkEmail.value
            emailFlag.value = false
            checkisCheck.value = isCheck.value
            pagination.current = 1
            isFirst.value = false
        }

        const submitBtn = () => {
            let emailReg = /^([\w]+)(.[\w]+)*@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
            if (!emailReg.test(changeEmailVal.value))
                return ElMessage.error("请填写正确的邮箱格式");
            let param = {};
            param.email = changeEmailVal.value;
            param.isDefault = switchVal.value == true ? 1 : 0;
            if (addEmailTitle.value == "添加电子邮箱") {
                proxy.$post("v3/member/front/memberEmail/add", param).then((res) => {
                    if (res.state == 200) {
                        ElMessage.success(res.msg);
                        addEmailTitle.value = "选择电子邮箱"
                        pagination.current = 1
                        isFirst.value = false
                        getEmail();
                    } else {
                        ElMessage.error(res.msg);
                    }
                });
            }
            if (addEmailTitle.value == "编辑电子邮箱") {
                param.emailId = isCheck.value
                proxy.$post("v3/member/front/memberEmail/edit", param).then((res) => {
                    if (res.state == 200) {
                        ElMessage.success(res.msg);
                        addEmailTitle.value = "选择电子邮箱"
                        pagination.current = 1
                        getEmail();
                    } else {
                        ElMessage.error(res.msg);
                    }
                });
            }
        };

        // 获取邮箱列表
        const getEmail = () => {
            let param = {};
            if (isCheck.value != '') {
                param.current = pagination.current;
                param.pageSize = pagination.pageSize;
            } else {
                param.current = '';
                param.pageSize = '';
            }
            proxy.$get("v3/member/front/memberEmail/list", param).then((res) => {
                if (res.state == 200) {
                    emailList.data = res.data.list;
                    pagination.total = res.data.pagination.total;
                    if (isCheck.value == '' && isFirst.value) {
                        let isTrue = false
                        res.data.list.map(item => {
                            if (item.isDefault == 1) {
                                GetPageEmail.value = item.email
                                checkEmail.value = item.email
                                DefaultEmail.value = true
                                isCheck.value = item.emailId
                                checkisCheck.value = item.emailId
                                isTrue = true
                            }
                        })
                        if (isTrue == false) {
                            GetPageEmail.value = res.data.list[0].email
                            checkEmail.value = res.data.list[0].email
                            DefaultEmail.value = false
                            isCheck.value = res.data.list[0].emailId
                            checkisCheck.value = res.data.list[0].emailId
                        }
                    } else {
                        if (isCheck.value == '' && !isFirst.value && res.data.list.length != 0) {
                            let isTrue = false
                            res.data.list.map(item => {
                                if (item.isDefault == 1) {
                                    checkEmail.value = item.email
                                    checkisCheck.value = item.emailId
                                    isTrue = true
                                }
                            })
                            // if (isTrue == false) {
                            //     GetPageEmail.value = res.data.list[0].email
                            //     checkEmail.value = res.data.list[0].email
                            //     DefaultEmail.value = false
                            //     isCheck.value = res.data.list[0].emailId
                            //     checkisCheck.value = res.data.list[0].emailId
                            // }
                        }
                        isCheck.value = checkisCheck.value
                        DefaultEmail.value = itemIsDefalut.value

                    }
                }
            });
        }

        // 获取发票列表
        const GetOrderList = () => {
            let param = {}
            param.pageSize = paginationList.pageSize
            param.current = paginationList.current
            param.invoiceStatus = 0
            proxy.$get('v3/business/front/openInvoice/list', param).then((res) => {
                if (res.state == 200) {
                    orderList.data = res.data.list
                }
                // console.log(res)
            })
        }

        // 获取发票信息
        const getInvoice = () => {
            proxy.$get('v3/member/front/memberInvoice/detail').then(res => {
                if (res.state == 200) {
                    invoiceInfo.data = res.data
                }
            })
        }
        // 新增或者编辑邮箱
        const addOrEditEmail = (type) => {
            switch (type) {
                case 1:
                    addEmail()
                    break;
                case 2:
                    GoEditEmail()
                    break;
            }
        }

        // table 选择框改变
        const handleSelectionChange = (val) => {
            let invoiveOrderSnList = val.map(item => item.orderSn)
            invoiveOrderSn.value = invoiveOrderSnList.join(',')
            // console.log(val,invoiceId.value,invoiveOrderSn.value,12)
        }
        const handleCurrentListChange = (current) => {
            paginationList.current = current;
            GetOrderList()
        }

        // 申请开票
        const applyInvoice = () => {
            let param = {}
            param.invoiceEmail = GetPageEmail.value
            param.invoiceId = invoiceInfo.data.invoiceId
            param.orderSns = invoiveOrderSn.value
            console.log(param)
            proxy.$post('v3/business/front/openInvoice/apply', param).then(res => {
                if (res.state == 200) {
                    paginationList.current = 1
                    ElMessage.success(res.msg);
                    // console.log(res)
                    isNext.value = false
                    GetOrderList()
                } else {
                    ElMessage.error(res.msg);
                }
            })
        }


        onMounted(() => {
            getEmail()
            GetOrderList()
            getInvoice()
        })
        return {
            isNext,
            GetPageEmail,
            DefaultEmail,
            emailFlag,
            addEmailTitle,
            changeEmailVal,
            switchVal,
            checkEmail,
            checkisCheck,
            isFirst,
            emailList,
            pagination,
            isCheck,
            itemIsDefalut,
            checkType,
            orderList,
            paginationList,
            invoiceInfo,
            invoiceId,
            invoiveOrderSn,

            nextBtn,
            getEmail,
            addOrEditEmail,
            addEmail,
            GoEditEmail,
            handleCurrentChange,
            chooseEmail,
            EditEmail,
            closeEmail,
            backEmailList,
            subEmail,
            submitBtn,
            GetOrderList,
            handleCurrentListChange,
            getInvoice,
            handleSelectionChange,
            applyInvoice,

        };
    }
};
</script>
  
<style lang="scss" scoped>
@import "../../../style/member/applyBill.scss";
</style>